"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.surveyTab = exports.surveyRenderingReset = exports.surveyRendering = exports.surveyRenderSuccess = exports.surveyRenderError = exports.surveyLatest = exports.surveyImpactList = exports.surveyGoToFund = exports.surveyFundList = exports.surveyConfigurationSaveReset = exports.surveyConfigurationSave = exports.surveyConfigurationGet = exports.surveyConfigurationFetch = void 0;
var _surveyRendering = require("./surveyRendering.constant");
// @flow

// common success
var surveyRenderSuccess = function surveyRenderSuccess(actionType, data) {
  return {
    type: _surveyRendering.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.surveyRenderSuccess = surveyRenderSuccess;
var surveyRenderError = function surveyRenderError(actionType, error) {
  return {
    type: _surveyRendering.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * survey html
 * @param payload
 * @returns api response
 * @description this function used to fetch survey html.
 */
exports.surveyRenderError = surveyRenderError;
var surveyRendering = function surveyRendering(payload) {
  return {
    type: _surveyRendering.actionTypes.SURVEY_RENDERING,
    payload: payload
  };
};

/**
 * survey html
 * @param payload
 * @returns api response
 * @description this function used to fetch survey html.
 */
exports.surveyRendering = surveyRendering;
var surveyLatest = function surveyLatest(payload) {
  return {
    type: _surveyRendering.actionTypes.SURVEY_LATEST,
    payload: payload
  };
};

/**
 * survey html
 * @param payload
 * @returns api response
 * @description this function used to fetch survey html of particular fund.
 */
exports.surveyLatest = surveyLatest;
var surveyGoToFund = function surveyGoToFund(payload) {
  return {
    type: _surveyRendering.actionTypes.SURVEY_GO_TO_FUND,
    payload: payload
  };
};

/**
 * survey tab
 * @param payload
 * @returns api response
 * @description this function used to fetch survey tab.
 */
exports.surveyGoToFund = surveyGoToFund;
var surveyTab = function surveyTab(payload) {
  return {
    type: _surveyRendering.actionTypes.SURVEY_TAB,
    payload: payload
  };
};

/**
 * Reset survey rendering
 * @param payload
 * @returns api response
 * @description this function used to user forgot password by its credencials.
 */
exports.surveyTab = surveyTab;
var surveyRenderingReset = function surveyRenderingReset(payload) {
  return {
    type: _surveyRendering.actionTypes.SURVEY_RENDERING_RESET,
    payload: payload
  };
};

/**
 * survey configuration get
 * @param payload
 * @returns api response
 * @description this function used to fetch survey configuration.
 */
exports.surveyRenderingReset = surveyRenderingReset;
var surveyConfigurationGet = function surveyConfigurationGet(payload) {
  return {
    type: _surveyRendering.actionTypes.SURVEY_CONFIGURATION_GET,
    payload: payload
  };
};

/**
 * survey configuration fetch
 * @param payload
 * @returns api response
 * @description this function used to fetch survey configuration.
 */
exports.surveyConfigurationGet = surveyConfigurationGet;
var surveyConfigurationFetch = function surveyConfigurationFetch(payload) {
  return {
    type: _surveyRendering.actionTypes.SURVEY_CONFIGURATION_FETCH,
    payload: payload
  };
};

/**
 * survey configuration save
 * @param payload
 * @returns api response
 * @description this function used to save survey configuration.
 */
exports.surveyConfigurationFetch = surveyConfigurationFetch;
var surveyConfigurationSave = function surveyConfigurationSave(payload) {
  return {
    type: _surveyRendering.actionTypes.SURVEY_CONFIGURATION_SAVE,
    payload: payload
  };
};

/**
 * survey configuration save reset
 * @param payload
 * @returns api response
 * @description this function used to reset survey configuration save.
 */
exports.surveyConfigurationSave = surveyConfigurationSave;
var surveyConfigurationSaveReset = function surveyConfigurationSaveReset(payload) {
  return {
    type: _surveyRendering.actionTypes.SURVEY_CONFIGURATION_SAVE_RESET,
    payload: payload
  };
};

/**
 * survey fund list
 * @param payload
 * @returns api response
 * @description this function used to fetch survey fund list.
 */
exports.surveyConfigurationSaveReset = surveyConfigurationSaveReset;
var surveyFundList = function surveyFundList(payload) {
  return {
    type: _surveyRendering.actionTypes.SURVEY_FUND_LIST,
    payload: payload
  };
};

/**
 * survey impact list
 * @param payload
 * @returns api response
 * @description this function used to fetch survey impact list.
 */
exports.surveyFundList = surveyFundList;
var surveyImpactList = function surveyImpactList(payload) {
  return {
    type: _surveyRendering.actionTypes.SURVEY_IMPACT_LIST,
    payload: payload
  };
};
exports.surveyImpactList = surveyImpactList;